import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ApplicationOfferDisclosure } from "common";

@UntilDestroy()
@Component({
    selector: 'ifa-calculator-disclosures',
    templateUrl: './calculator-disclosures.component.html',
    standalone: false
})
export class CalculatorDisclosuresComponent implements OnInit {
    disclosures: ApplicationOfferDisclosure[];

    constructor(private readonly route: ActivatedRoute) { }

    ngOnInit(): void {
        this.route.data.pipe(untilDestroyed(this)).subscribe(data => {
            this.disclosures = data.disclosures;
        })
    }
}